<template>
    <div>
        <ViewItem v-if="!!template" :item="template" @success="alertSuccess" @delete-item="deleteType"
            @cancel="template = null" @error="alertError"></ViewItem>

        <b-overlay v-else :show="tableLoading" rounded="sm" >
            <ListItems title="Templates" @show-item="showTemplate" ref="table">
                <b-button block variant="primary" @click="template = {}">
                    <img v-b-tooltip.hover :title="$addLabel()" v-if="hasPermissionCreate"
                        src="@/assets/images/icon/blue-add.svg">
                </b-button>

            </ListItems>
        </b-overlay>
    </div>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import utilityMixins from '@/mixins/utilityMixins'
import permissionsMixins from '@/mixins/permissionsMixins'
import errorHandlingMixins from '@/mixins/errorHandlingMixins'

import ListItems from './ListItems'
import ViewItem from './ViewItem'

export default {
    name: 'reviewTemplates',
    components: {
        ListItems,
        ViewItem,
    },
    mixins: [popupMixins, utilityMixins, permissionsMixins, errorHandlingMixins],
    data: () => {
        return {
            template: null,
            tableLoading: false,
        }
    },
    async created() {
        this.$store.dispatch('checkoffTypes/fetchAll')
        this.tableLoading = true;
        await this.$store.dispatch('checkoffTemplates/fetchAll', {})
        this.tableLoading = false;
    },

    computed: {
        componentName() { return this.$translate('review_template') },
        templates() {
            const templates = this.$store.state.checkoffTemplates.templates
            console.log('templates', templates)
            return templates
        },
        user_permissions() {
            return this.$store.getters.user_permissions
        },
    },

    methods: {
        showTemplate(id) {
            this.template = this.templates.find(x => x.id === id)
        },

        async alertSuccess(action, message) {
            //const message= isUpdated? 'Review template updated successfully' : 'Review template created successfully'
            //const action= isUpdated? 'Updated':'Created'

            this.genericToast(this.componentName, this.$translate(`${action}d`), 'success', `${this.componentName} ${message}`)
            await this.$store.dispatch('checkoffTemplates/fetchAll', {forceReload: true})
            //this.doToast('Success', message, 'success')
            this.template = null
        },

        alertError(error) {
            // let message = error.message
            // console.log('mmm', message)
            // const interror = 'Internal Server Error'
            // if (interror == error.message) {

            this.genericToast(`${this.componentName}`, this.$translate('error'), 'danger', `${error.message}`)

            // }
        }
    },
}
</script>
<style></style>
